import { t } from "i18next";
import { useState } from "react";
import ReactDOM from "react-dom";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
const ForgotPassword = () => {
  const [tab, setTab] = useState("email");
  const navigate = useNavigate();

  return (
    <div
      id="mc-animate-container"
      className="v-base v-detail-base fade-enter-done"
    >
      <div className="_container_box">
        <div className="forgot-password">
          <div id="this_home_bg" className="form" />
          <span onClick={() => navigate("/")} className="shell_return_icon">
            <IoIosArrowBack className="am-icon am-icon-icon-back_2193da1f am-icon-md" />
          </span>
          <div className="form_logo">
            <img src="/assets/chorki/logo.svg" alt />
          </div>
          <div className="form_wrap">
            <div className="login-form-bg">
              <div className="form_header">
                <div className="form_title">Forgot password</div>
                <span className="form_subtitle">
                  Please retrieve your password in the following ways.
                </span>
              </div>
              <form className="form-content" autoComplete="off">
                <div className="outter_form">
                  <div className="form-group">
                    <div className="fixed_list">
                      <input
                        type="text"
                        autoComplete="off"
                        className="form-control"
                        name="username"
                        placeholder="Username"
                      />
                      <span className="input-icon">
                        <svg className="am-icon am-icon-icon-username_e61fd380 am-icon-md">
                          <use xlinkHref="#icon-username_e61fd380" />
                        </svg>
                      </span>
                    </div>
                    <div className="panel panel-default">
                      <strong className="undefined" />
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="fixed_list">
                      <input
                        type="text"
                        autoComplete="off"
                        className="form-control"
                        name="email"
                        placeholder="Email"
                      />
                      <span className="input-icon">
                        <svg className="am-icon am-icon-icon-email_2550bab6 am-icon-md">
                          <use xlinkHref="#icon-email_2550bab6" />
                        </svg>
                      </span>
                    </div>
                    <div className="panel panel-default">
                      <strong className="undefined" />
                    </div>
                  </div>
                  <button type="button" className="submit-btn">
                    Reset
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
